<template>
    <el-dialog :title="$t('asset.component_CreateMemory_dialog_title')" :visible.sync="dialog.show" destroy-on-close :close-on-click-modal="false" width="520px" top="20px" @close="handleDialogClose">
        <el-form ref="newDialogForm" size="medium" label-position="top">
            <el-form-item :label="$t('asset.component_CreateMemory_form_item_label_1')" required>
                <el-input :placeholder="$t('asset.component_CreateMemory_form_item_placeholder_1')" v-model="dialog.form.name"></el-input>
            </el-form-item>
            <el-form-item :label="$t('asset.component_CreateMemory_form_item_label_2')" required>
                <el-select v-model="dialog.form.sourceLang" :placeholder="$t('asset.component_CreateMemory_form_item_placeholder_2')" @change="sourceLangChange" style="width:126px;">
                    <template v-for="(item,key) in LANGUAGE_DICT">
                        <el-option :key="key" :value="key" :label="item.name"></el-option>
                    </template>
                </el-select>
                <svg-icon name="ib-arrow-right" className="fonts-20 margin-x-5"></svg-icon>
                <el-select v-model="dialog.form.targetLang" :placeholder="$t('asset.component_CreateMemory_form_item_placeholder_3')" style="width:126px;">
                    <template v-for="(item,key) in LANGUAGE_DICT">
                        <el-option :key="key" :value="key" :label="item.name" :disabled="dialog.form.sourceLang === key"></el-option>
                    </template>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('asset.component_CreateMemory_form_item_label_3')" required v-if="userInfo.organizationType === 'ENTERPRISE'">
                <el-select :placeholder="$t('asset.component_CreateMemory_form_item_placeholder_4')" v-model="dialog.form.teamId" style="width:126px;">
                    <template v-for="item in teamOptions">
                        <el-option :key="item.value" :value="item.value" :label="item.text"></el-option>
                    </template>
                </el-select>
            </el-form-item>
            <el-form-item size="small" :label="$t('asset.component_CreateMemory_form_item_label_4')" v-if="userInfo">
                <div class="fonts-12 margin-b-16 line-height-0">{{$t('asset.component_CreateMemory_form_item_message_1', {type: 'xlsx/xls/tmx/sdltm', size: userInfo.featureConfig.singleFileSize})}}<el-button type="text" class="color-link padding-0" :disabled="dialog.templateLoading" @click="downloadTemplateEvent">excel</el-button></div>
                <upload-oss :multiple="true" ref="uploadOssDom" accept=".xls,.xlsx,.tmx,.sdltm" :size="userInfo.featureConfig.singleFileSize" :params="{}"></upload-oss>
            </el-form-item>
        </el-form>
        <div slot="footer" class="text-center">
            <el-button round plain size="small" @click="dialog.show = false">{{$t('asset.component_CreateMemory_dialog_btn_label_1')}}</el-button>
            <el-button round type="primary" size="small" style="margin-left:30px;" :loading="dialog.loading" @click="saveBtnEvent">{{$t('asset.component_CreateMemory_dialog_btn_label_2')}}</el-button>
        </div>
    </el-dialog>
</template>
<script>
import { mapState } from 'vuex';
import cookie from 'vue-cookies';
import fileDownload from 'js-file-download';
import config from '@/utils/config';
import { memoryApi, commonApi } from '@/utils/api';
import UploadOss from '@/components/UploadOss';
export default {
    components: { UploadOss },
    props:{
        source:{
            type: String,
            default: '',
        },
        target:{
            type: String,
            default: '',
        }
    },
    computed: {
        ...mapState({
            userInfo: state => state.user.userData,
            LANGUAGE_DICT: state => state.common.LANGUAGE_DICT,
        }),
    },
    data(){
        return {
            uploadUrl:memoryApi.uploadMemoryFile,
            uploadBtnLoading:false,
            uploadStatus:'', //空=不显示，1=成功，0=失败
            uploadFileName:'',
            uploadHeaders:{
                'Authorization':cookie.get("token")
            },
            dialog:{
                show:false,
                loading:false,
                templateLoading:false,
                form:{
                    name:'',
                    sourceLang:'',
                    targetLang:'',
                    filePath:'',
                    teamId: '',
                }
            },
            teamOptions: [],
        }
    },
    methods:{
        sourceLangChange(val){
            if(val === this.dialog.form.targetLang){
                if(val === 'zh'){
                    this.dialog.form.targetLang = 'en';
                }else{
                    this.dialog.form.targetLang = 'zh';
                }
            }
        },
        setShow(val){
            this.dialog.show = val;
            this.dialog.form.sourceLang = this.source;
            this.dialog.form.targetLang = this.target;
            if(this.userInfo.organizationType === 'ENTERPRISE') {
                this.queryTeamOptions();
            }
        },
        handleDialogClose(){
            this.dialog.form = {
                name:'',
                sourceLang:'',
                targetLang:'',
                filePath:[],
                teamId: '',
            };
            this.uploadFileName = '';
            this.uploadStatus = '';
        },
        downloadTemplateEvent(){
            this.dialog.templateLoading = true;
            let downMsg = this.$message({
                message: this.$t('asset.component_CreateMemory_downloadTemplate_message'),
                type: 'info',
                iconClass: 'el-icon-loading',
                duration: 0,
            });
            this.$ajax.get(memoryApi.downloadTemplate).then(res=>{
                if(res.status === 200){
                    if(res.data){
                        window.open(res.data);
                    }else {
                        this.$message.error(this.$t('asset.component_CreateMemory_validation_message_1'));
                    }
                }
            }).finally(()=>{
                this.dialog.templateLoading = false;
                downMsg.close();
            })
        },
        saveBtnEvent(){
            let fileList = this.$refs.uploadOssDom.getOssFiles();
            let url = memoryApi.memoryDB;
            let postData = this.dialog.form;
            if(!postData.name){
                this.$message.error(this.$t('asset.component_CreateMemory_validation_message_2'));
                return;
            }
            if(!postData.sourceLang || !postData.targetLang){
                this.$message.error(this.$t('asset.component_CreateMemory_validation_message_3'));
                return;
            }
            postData.filePath = fileList;
            this.dialog.loading = true;
            this.$ajax.post(url,postData).then(res=>{
                if(res.status === 200){
                    this.$message.success(this.$t('asset.component_CreateMemory_validation_message_4'));
                    this.dialog.show = false;
                    this.$emit('success', res.data);
                    // this.initPage();
                }
            }).finally(()=>{
                this.dialog.loading = false;
            });
        },
        queryTeamOptions() {
            let url = commonApi.queryTeamFilterOptions;
            this.$ajax.get(url).then(res => {
                if(res.status === 200) {
                    this.teamOptions = res.data.teamFilters;
                    this.dialog.form.teamId = this.teamOptions[0].value
                }
            });
        },
    },
    mounted() {

    }
}
</script>
